module.exports = __webpack_public_path__ + "img/list_title.3cb9cfc9.png";